import React, { useMemo, useState } from 'react';
import { Drawer } from '@mui/material';

import MenuIcon from '@/assets/icons/menu.svg?react';
import AgioLogo from '@/assets/svg/agio-logo-small.svg?react';
import { generateHeader } from '@/layouts/MainLayout/utils/helpers';
import { useBreakpointsCtx } from '@/providers/BreakpointsProvider/BreakpointsContext.hooks';
import { Sidebar } from '@/layouts/MainLayout/components/Sidebar/Sidebar';
import {
  StyledHeaderContainer,
  StyledDesktopDrawerPaper,
  StyledMenuButton,
  StyledMobileDrawerPaper,
  StyledLogoLink,
} from '@/layouts/MainLayout/components/HeaderWithNavigation/HeaderWithNavigation.styled';
import { THeader } from '@/layouts/MainLayout/utils/types';
import { ERoutes } from '@/types/routes';

interface IHeaderWithNavigationProps {
  header?: THeader;
}

export const HeaderWithNavigation = ({ header }: IHeaderWithNavigationProps) => {
  const { isDesktop } = useBreakpointsCtx();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const handleMenuToggle = () => setIsMenuOpen(prev => !prev);

  const headerToDisplay = generateHeader(header);

  const sidebar = useMemo(() => {
    return (
      <Drawer
        variant={isDesktop ? 'permanent' : 'temporary'}
        anchor="left"
        open={isMenuOpen}
        onClose={handleMenuToggle}
        slotProps={{
          paper: isDesktop
            ? { component: StyledDesktopDrawerPaper }
            : { component: StyledMobileDrawerPaper },
        }}
      >
        <Sidebar handleMenuToggle={handleMenuToggle} />
      </Drawer>
    );
  }, [isMenuOpen, isDesktop]);

  return (
    <>
      {headerToDisplay && (
        <StyledHeaderContainer isDesktop={isDesktop}>
          {!isDesktop && (
            <StyledMenuButton onClick={handleMenuToggle}>
              <MenuIcon color="inherit" width={25} height={25} />
            </StyledMenuButton>
          )}

          {!isDesktop && (
            <StyledLogoLink to={ERoutes.DASHBOARD}>
              <AgioLogo width="100%" height="100%" />
            </StyledLogoLink>
          )}

          {headerToDisplay}
        </StyledHeaderContainer>
      )}

      {sidebar}
    </>
  );
};
